module.exports = __webpack_public_path__ + "static/media/iteq-logo.c7d3a415.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomePage/Iteq/assets/iteq-logo.png
// module id = 2706
// module chunks = 0